import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { SharedService } from '../shared.service';

@Component({
    selector: 'app-password-expiry-reminder',
    templateUrl: './password-expiry-reminder.component.html',
    styleUrl: './password-expiry-reminder.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class PasswordExpiryReminderComponent implements OnInit {

  daysLeft: number | null = null;

  constructor(private _shared: SharedService, private router: Router) { }

  ngOnInit(): void {
    this._shared.passwordExpiryWarningDays$.subscribe(days => {
      this.daysLeft = days;
    });
  }

  changePasswordNow() {
    this.daysLeft = null;
    this._shared.passwordExpiryWarningDays$.next(null);
    this.router.navigate(['app', 'sales', 'my-profile']);
  }

  remindLater() {
    this.daysLeft = null;
    this._shared.passwordExpiryWarningDays$.next(null);
  }
}
